// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1697": "Dennis","2809": "Sandbox","4154": "Reports","9257": "Stories",}[chunkId] || chunkId) + ".css"
}